module.exports = __webpack_public_path__ + "static/media/support.ad2581d0.svg";